export default __webpack_public_path__ + "static/media/adrenalinesurge.70a05f9b.png";